<script lang="ts" setup>
// Corner marker so it is obvious at a glance which build is on screen.
// Renders nothing at all in production.
import { APP_ENV, IS_PRODUCTION_BUILD } from '@/constants/app-env'

const appVersion = __APP_VERSION__
</script>

<template>
  <div v-if="!IS_PRODUCTION_BUILD" class="env-badge" :class="`env-badge--${APP_ENV}`">
    <span class="env-badge__env">{{ APP_ENV }}</span>
    <span class="env-badge__version">v{{ appVersion }}</span>
  </div>
</template>

<style scoped>
.env-badge {
  position: fixed;
  bottom: 8px;
  left: 8px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  opacity: 0.9;
  pointer-events: none; /* never intercept clicks on the visualisation */
  user-select: none;
}

.env-badge--dev {
  background: rgba(217, 119, 6, 0.95); /* amber */
}

.env-badge--local {
  background: rgba(37, 99, 235, 0.95); /* blue */
}

.env-badge__version {
  font-weight: 500;
  opacity: 0.85;
}

@media print {
  .env-badge {
    display: none;
  }
}
</style>
